import {
  SprayOrSprayZoneChartConfigDto,
  BatterReportChartConfigDto,
  SprayOrSprayZoneChartView,
  BatterSessionReportChartConfigDto,
  ChartType,
  PracticeBatterSessionReportChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig = BatterReportChartConfigDto | BatterSessionReportChartConfigDto | PracticeBatterSessionReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<SprayOrSprayZoneChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  configKey: keyof TReportConfig;
};

const SprayOrSprayZoneChartSidebar = <T extends ReportConfig>({ chartConfig, setTempLayout, tempLayout, chartId, configKey }: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId, chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['SprayChart', 'SprayZone'] satisfies SprayOrSprayZoneChartView[]}
        selected={chartConfig.viewChartAs}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [configKey]: { ...tempLayout[configKey], viewChartAs: selected },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default SprayOrSprayZoneChartSidebar;
